<template>
  <div class="overflow-auto">
    <!--Items Selected -->
    <div>
      <b-form-group v-if="selectedItems.length > 0 && mainAction == 'remove'">
        <small class="text-muted" v-if="mainAction == 'remove'">{{itemType}} a remover: </small>
        <b-form-tag
          id="items-to-remove"
          v-for="item in selectedItems"
          size="sm"
          class="mb-2"
          variant="danger"
          :key="item"
          @remove="omitItem(item)">
          {{ item }}
        </b-form-tag>
      </b-form-group>
    </div>
    <!-- Filter items -->
    <div>
      <b-form-group
        label-for="filter-input"
        label-size="sm"
        class="mb-0">
        <b-input-group size="sm">
          <b-input-group-prepend is-text>
            <i class="fal fa-search"></i>
          </b-input-group-prepend>
          <b-form-input
            id="filter-input"
            v-model="search"
            type="search"
            placeholder="Buscar ...">
          </b-form-input>
        </b-input-group>
      </b-form-group>
      <small>Cantidad de {{itemType}}: {{ totalItems }}</small>
      <b-table
        id="item-table"
        hover
        small
        fixed
        head-variant="light"
        :filter="search"
        :items="alreadyItems"
        :per-page="perPage"
        :current-page="currentPage"
        :fields="mainItemColumns"
        @filtered="onFiltered">
        <template #cell()="data">
          <p v-if="data.field.key != 'id'" :title="data.value">{{ data.value }}</p>
          <p v-else>{{ data.value }}</p>
        </template>
        <template #cell(actions)="row" v-if="available">
          <b-button size="sm" title="Quitar" @click="removeItem(row)" variant="outline-danger"  v-if="mainAction == 'remove'">
            <i class="fas fa-minus"></i>
          </b-button>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalItems"
        :per-page="perPage"
        aria-controls="item-table"
        first-number
        last-number
      ></b-pagination>
    </div>
    <!-- Add / Remove actions -->
    <div>
      <b-button
        v-show="mainAction == 'remove' && selectedItems.length > 0"
        size="sm"
        @click="deleteItems"
        variant="danger"><i class="fal fa-minus"></i> Remover {{itemType}}
      </b-button>
      <b-button
        v-show="mainAction == 'remove' && available && selectedItems.length <= 0 && canAddItems"
        size="sm"
        @click="addItems"
        variant="info"><i class="fal fa-plus"></i> Agregar {{itemType}}
      </b-button>
    </div>
    <!-- SELECT NEW ITEMS MODAL-->
    <b-modal
      :id="modalId"
      :size="modalSize"
      :ref="modalId"
      :title="modalTitle"
      @show="resetModal"
      @hidden="resetModal"
    >
      <b-form-group v-if="selectedNewItems.length > 0">
        <small class="text-muted">{{itemType}} a agregar: </small>
        <b-form-tag
          id="items-to-add"
          v-for="item in selectedNewItems"
          size="sm"
          class="mb-2"
          variant="info"
          :key="item"
          @remove="omitNewItem(item)">
          {{ item }}
        </b-form-tag>
      </b-form-group>
      <!-- Filter items -->
      <b-form-group
        label-for="filter-new-input"
        label-size="sm"
        class="mb-0">
        <b-input-group size="sm">
          <b-input-group-prepend is-text>
            <i class="fal fa-search"></i>
          </b-input-group-prepend>
          <b-form-input
            id="filter-new-input"
            v-model="searchNew"
            type="search"
            placeholder="Buscar ...">
          </b-form-input>
        </b-input-group>
      </b-form-group>
      <small>Cantidad de {{itemType}}: {{ totalNewItems }}</small>
      <b-table
        id="new-item-table"
        hover
        small
        fixed
        head-variant="light"
        :filter="searchNew"
        :items="newItemsAvailable"
        :per-page="perPage"
        :current-page="currentPageSelect"
        :fields="modalItemColumns || mainItemColumns"
        @filtered="onFilteredNew">
        <template #cell()="data">
          <p v-if="data.field.key != 'id'" :title="data.value">{{ data.value }}</p>
          <p v-else>{{ data.value }}</p>
        </template>
        <template #cell(actions)="row" v-if="available">
          <b-button size="sm" title="Agregar" @click="addNewItem(row)" variant="outline-info">
            <i class="fas fa-plus"></i>
          </b-button>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPageSelect"
        :total-rows="totalNewItems"
        :per-page="perPage"
        aria-controls="new-item-table"
        first-number
        last-number
      ></b-pagination>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()">
          Cancelar
        </b-button>
        <b-button v-show="selectedNewItems.length > 0" size="sm" variant="primary" @click="updateItems()">
          Agregar {{itemType}}
        </b-button>
      </template>
    </b-modal>
    <LoadingMask :active="loadingRoles"/>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import LoadingMask from '@/components/generic/LoadingMask.vue'

@Component({
  components: {
    LoadingMask
  }
})
export default class ItemsTable extends Vue {
  @Prop({ required: true, default: 'item' })
  itemType: string

  @Prop({ required: true, default: [] })
  items: any[]

  @Prop({ required: true })
  mainItemColumns: any[]

  @Prop({ required: false })
  modalItemColumns: any[]

  @Prop({ required: true, default: 'add' })
  mainAction: string

  @Prop({ required: true, default: false })
  available: boolean

  @Prop({ required: true, default: [] })
  allItems: any[]

  @Prop({ required: false, default: 'lg' })
  modalSize: string

  @Prop({ required: false, default: true })
  canAddItems: boolean

  PAGE_SIZE = 500
  loadingRoles = false

  totalItems: number = 0
  search: string = ''
  filteredItems: any[] = []
  selectedItems: string[] = []
  selectedItemIds: number[] = []
  perPage = 10
  currentPage = 1

  totalNewItems: number = 0
  searchNew: string = ''
  filteredNewItems: any[] = []
  selectedNewItems: string[] = []
  selectedNewItemIds: number[] = []
  currentPageSelect = 1

  created () {
    this.selectedItems = []
    this.selectedItemIds = []
  }

  /**
   * Creates modal identifier based on itemType property
   */
  get modalId () {
    return 'modal-select-' + this.itemType
  }

  /**
   * Create title to modal component
   * @returns string title
   */
  get modalTitle () {
    return 'Selección de ' + this.itemType
  }

  /**
   * Get already items filtered
   * @returns items
   */
  get alreadyItems () {
    let alreadyFiltered = this.selectedItems.length > 0 ? this.filteredItems : this.items
    this.totalItems = alreadyFiltered.length
    return alreadyFiltered
  }

  /**
   * Returns new items available to select and add to already items
   * if new items has been selected and already exists on 'items' they will be skipped
   * otherwise will be skipped already items exists on 'items'
   * @returns items available
   */
  get newItemsAvailable () {
    let itemsAvailable = []
    if (this.selectedNewItems.length > 0) {
      itemsAvailable = this.filteredNewItems.filter(it => !this.selectedNewItemIds.includes(it.id) && !this.items.find(item => item.id === it.id))
    } else if (this.allItems.length > 0) {
      itemsAvailable = this.allItems.filter(it => !this.items.find(item => item.id === it.id))
    }
    this.totalNewItems = itemsAvailable.length
    return itemsAvailable
  }

  /**
   * Filter funtion to already items
   */
  onFiltered (filteredItems: any) {
    this.totalItems = filteredItems.length
    this.currentPage = 1
  }

  /**
   * Filter funtion to new items available
   */
  onFilteredNew (filteredNewItems: any) {
    this.totalNewItems = filteredNewItems.length
  }

  /**
   * Add an item to considered to remove from already items
   * @param item to considered remove
   */
  removeItem (item: any) {
    this.selectedItems.push(item.item.id + ':' + item.item.name)
    this.selectedItemIds.push(item.item.id)
    this.filteredItems = this.items.filter(it => !this.selectedItemIds.includes(it.id))
    this.totalItems = this.filteredItems.length
  }

  /**
   * Add an item to considered to add in already items
   * @param item to considered add
   */
  addNewItem (item: any) {
    if (!this.selectedNewItemIds.includes(item.item.id)) {
      this.selectedNewItems.push(item.item.id + ':' + item.item.name)
      this.selectedNewItemIds.push(item.item.id)
      this.filteredNewItems = this.allItems.filter(it => !this.selectedNewItemIds.includes(it.id))
    }
  }

  /**
   * Remove item from considered items to remove
   * @param item to omit
   */
  omitItem (item: any) {
    this.selectedItems.splice(this.selectedItems.indexOf(item), 1)
    this.selectedItemIds.splice(this.selectedItemIds.indexOf(parseInt(item.split(':')[0])), 1)
    this.filteredItems = this.items.filter(it => !this.selectedItemIds.includes(it.id))
  }

  /**
   * Remove item from considered items to add
   * @param item to omit
   */
  omitNewItem (item: any) {
    this.selectedNewItems.splice(this.selectedNewItems.indexOf(item), 1)
    this.selectedNewItemIds.splice(this.selectedNewItemIds.indexOf(parseInt(item.split(':')[0])), 1)
    this.filteredNewItems = this.allItems.filter(it => !this.selectedNewItemIds.includes(it.id))
  }

  /**
   * Display modal component
   */
  addItems () {
    this.$emit('load-items')
    this.$bvModal.show(this.modalId)
  }

  /**
   * Emit event to remove the selected items
   */
  deleteItems () {
    this.$emit('delete-items', this.selectedItemIds)
    this.selectedItems = []
    this.selectedItemIds = []
  }

  /**
   * Emit event to update with new selected items
   */
  updateItems () {
    if (this.selectedNewItems.length > 0) {
      this.$emit('update-items', this.selectedNewItemIds)
      this.selectedNewItems = []
      this.selectedNewItemIds = []
    }
    this.currentPageSelect = 1
    this.$bvModal.hide(this.modalId)
  }

  /**
   * Reset new items arrays
   */
  resetModal () {
    this.filteredNewItems = []
    this.selectedNewItems = []
    this.selectedNewItemIds = []
    this.currentPageSelect = 1
  }
}
</script>
